import { InputAdornment as MInputAdornment, InputAdornmentProps } from '@mui/material'

export const InputAdornment: React.FC<InputAdornmentProps> = (props) => {
  return <MInputAdornment {...props} />
}
